<template>
  <div class="home_box" style="position: relative">
    <div class="top_box">
      <div class="item_box" style="margin-right: 20px">
        <div class="title">
          企业信息
          <span class="more" @click="$router.push({ name: 'user_center' })"
            >查看更多</span
          >
        </div>
        <div class="info_item" style="margin-top: 20px">
          单位名称：<span class="val" style="font-weight: bold">{{
            company.company_name
          }}</span>
        </div>
        <div class="info_item">
          管理账号：<span class="val">{{ company.tel }}</span>
        </div>
        <div class="info_item">
          注册时间：<span class="val">{{
            $moment(company.company_create_time)
          }}</span>
        </div>
        <div class="user_info_box">
          <div class="item">
            <Icon type="md-cube" :size='20'/>
            <span style="color: #919191;margin-left:5px">企业余额：</span>
            <span>¥{{company.company_money}}</span>
          </div>
          <div class="item" style="margin-left: 30px">
            <Icon type="md-card" :size='20'/>
            <span style="color: #919191;margin-left:5px">支付类型：</span>
            <span>{{ company.pay_type ? "预付" : "后付" }}</span>
          </div>
          <div class="item" style="margin-left: 30px">
            <Icon type="md-clock" :size='20' />
            <span>配额日期：{{ company.quota_date }}号</span>
          </div>
        </div>
      </div>

      <div class="item_box">
        <div class="title">
          <span>
            设备信息 <span class="data">更新时间：{{$moment(new Date())}}</span>
          </span>
        </div>
        <div class="manage_content">
          <div class="item" style="margin-right: 50px">
            <div class="tit">总设备</div>
            <div class="count count2">
              <span>{{ info.total }}</span>
              <span class="symbol">台</span>
            </div>
          </div>
          <div class="item" style="margin-right: 50px">
            <div class="tit">离线</div>
            <div class="count count2">
              <span style="color: #b12318">{{ info.offLine }}</span>
              <span class="symbol">台</span>
            </div>
          </div>
          <div class="item">
            <div class="tit">故障</div>
            <div class="count count2">
              <span style="color: #b12318">{{ info.error }}</span>
              <span class="symbol">台</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="item_box" style="margin-top: 20px; padding: 18px 16px 80px">
      <div class="title">
        <span>
          数据概览 <span class="data">更新时间：{{$moment(new Date())}}</span>
        </span>
        <div class="r_date">
          <DatePicker
            type="month"
            placeholder="月份选择"
            style="width: 200px"
            :editable="false"
            v-model="date"
            @on-change="setDate"
          ></DatePicker>
        </div>
      </div>
      <div class="home_count">
        <div class="item" style="padding-right: 160px">
          <Row>
            <Col span="24" style="color: #999999; font-size: 14px"
              >当前员工数</Col
            >
            <Col span="24">
              <span class="val" id="count-user">{{ count.user }}</span>
            </Col>
          </Row>
        </div>
        <div class="item">
          <Row style="color: #999999; font-size: 14px">
            <Col span="8">打印数量</Col>
            <Col span="8">复印数量</Col>
            <Col span="8">扫描数量</Col>
          </Row>
          <Row>
            <Col span="8">
              <span class="val" id="count-print">{{ count.print }}</span>
            </Col>
            <Col span="8">
              <span class="val" id="count-copy">{{ count.copy }}</span>
            </Col>
            <Col span="8">
              <span class="val" id="count-scan">{{ count.scan }}</span>
            </Col>
          </Row>
        </div>
        <div class="item" style="padding-left: 80px">
          <Row>
            <Col span="24" style="color: #999999; font-size: 14px"
              >产生费用</Col
            >
            <Col span="24">
              <span class="val" id="count-money">{{ count.money }}</span>
            </Col>
          </Row>
        </div>
      </div>
    </div>
    <div class="float-box">
        <img class="icon float-service" style="margin-top: 15px;" src="../../assets/images/ic_float_service.png"  @mouseover="service_show = true" @mouseleave="service_show = false">
        <div class="float-service-box" v-if="service_show">
            <div class="title">联系服务商</div>
            <a href="tel:4001886966">   <div class="content">{{company.agent_tel}}</div></a>
            <div class="title">邮件帮助</div>
            <a href="mailto:support@aidprint.com"><div class="content email">{{company.agent_email}}</div></a>
        </div>
    </div>

    <Modal
      :width="650"
      footer-hide
      title="修改密码"
      v-model="modalPwd.visible"
      :mask-closable="false"
      :closable="false"
    >
      <div class="modal_title">
        请为账户设置新的密码，必须包含数字和字母，不低于6位！
      </div>

      <div style="margin-top: 40px">
        <Input
          v-model="modalPwd.password"
          style="width: 200px"
          size="large"
          type="password"
          placeholder="请输入新密码"
        />
      </div>
      <div style="margin: 20px 0 40px; display: flex; align-items: center">
        <Input
          v-model="modalPwd.rpassword"
          style="width: 200px"
          size="large"
          type="password"
          placeholder="请再次输入新密码"
        />
        <div class="btn_confirm" @click="savePWD">确认</div>
      </div>
    </Modal>
    <Spin fix v-if="loading">
      <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
      <div>加载中...</div>
    </Spin>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CountUp from "countup";
export default {
  name: "home",
  components: {},
  data() {
    return {
      service_show:false,
      loading: false,
      dateIndex: 0,
      data: {},
      profitData: {},
      modalPwd: {
        visible: false,
        password: "",
        rpassword: "",
      },
      startTime: "",
      endTime: "",
      agent: {},

      count: {
        user: 0,
        print: 0,
        copy: 0,
        scan: 0,
        money: 0,
      },
      date: new Date(),
      modal: {
        visible: false,
        password: "",
      },
      info: {
        total: 0,
        offLine: 0,
        error: 0,
      },
      sns: [],
    };
  },
  mounted() {
    this.getData();
    if (this.company.is_set_password == 1) this.modalPwd.visible = true;

    console.log('信息',this.company )
    this.getMachine();
  },
  computed: mapGetters({
    company: "company",
    machine: "machine",
  }),
  methods: {
    ...mapActions([
      "HomeData",
      "SavePassword",
      "GetMachine",
      "SocketConn",
      "SocketSend",
    ]),
    getData() {
      this.loading = true;
      this.HomeData({ date: this.$moment(this.date, "YYYY-MM") }).then(
        (res) => {
          const user = new CountUp("count-user", 0, res.user, 0, 1);
          user.start();

          const print = new CountUp("count-print", 0, res.print, 0, 1);
          print.start();

          const copy = new CountUp("count-copy", 0, res.copy, 0, 1);
          copy.start();

          const scan = new CountUp("count-scan", 0, res.scan, 0, 1);
          scan.start();

          const money = new CountUp("count-money", 0, res.money, 2, 1);
          money.start();
          this.loading = false;
        }
      );
    },
    getMachine() {
      this.SocketConn().then((result) => {
        this.GetMachine().then((res) => {
          this.info.total = res.machine.length;
          res.machine.map((item) => {
            this.sns.push(item.sn);
            this.SocketSend({
              action: 100003,
              value: {
                sn: item.sn,
              },
            });
          });
          this.info.error = res.error.length;
          let that = this;
          setTimeout(function(){
            let offline = 0;
            that.machine.map((item) => {
              if (item.machine_status == 0) {
                ++offline;
              }
            });
            that.info.offLine = offline;
          },500)
        });
      });
    },
    setDate(date) {
      this.date = date;
      this.getData();
    },
    savePWD() {
      if (this.modalPwd.password.length < 6) {
        this.$Message.error("密码过短,无法保存");
        return;
      }
      if (this.modalPwd.password === "123456") {
        this.$Message.error("不能与初始密码相同");
        return;
      }
       let pwdRegex = new RegExp("(?=.*[0-9])(?=.*[a-zA-Z]).{6,30}");
      if (!pwdRegex.test(this.modalPwd.password)) {
        this.$Message.error("密码必须包含数字和字母，长度不低于6位");
        return false;
      }
      this.SavePassword({
        id: this.company.user_id,
        password: this.modalPwd.password,
      }).then((res) => {
        if (res.status) {
          this.$Message.success("修改成功");
          this.modalPwd.visible = false;
          this.company.is_set_password = 0;
        } else {
          this.$Message.success("修改失败，不能与初始密码相同");
        }
      });
    },
  },
};
</script>

<style lang="less">
@import "./index.less";
</style>
